import AIRefineIcon from '@assets/icons/AIRefineIcon'
import UndoIcon from '@assets/icons/UndoIcon'
import { colors } from '@globals/themes/defaultTheme'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import useUpgradeLicense from '@shared/licensing/useUpgradeLicense'
import { AppPermission } from '@shared/permissions'
import stripHtml from '@shared/utils/stripHtml'
import { T, useT } from '@transifex/react'
import { useFormContext, useWatch } from 'react-hook-form'
import useMessageRefinement from './useMessageRefinement'
import { RecognitionFormData } from './useSendRecognitionForm'

const RefineMessageButton: React.FC = () => {
  const {
    refineMessage,
    deleteRefinementMessage,
    hasRefined,
    isPendingRefineMessage,
    isPendingUndoRefinedMessage,
  } = useMessageRefinement()
  const { control } = useFormContext<RecognitionFormData>()
  const message = useWatch({ control, name: 'message' })
  const t = useT()
  const { interceptClick } = useUpgradeLicense()
  const handleClick = (event: React.MouseEvent) => {
    interceptClick(
      event as React.MouseEvent<HTMLAnchorElement, MouseEvent>,
      hasAppPermission =>
        hasAppPermission('refinementApp', AppPermission.RefinementAppUpgradeLicense),
      async () => await refineMessage(),
    )
  }

  return (
    <Stack direction="row" alignItems="center" useFlexGap gap={1} sx={{ mt: 0.25 }}>
      <Chip
        id="refineButton"
        disabled={
          stripHtml(message).length === 0 || isPendingRefineMessage || isPendingUndoRefinedMessage
        }
        onClick={handleClick}
        variant="outlined"
        icon={<AIRefineIcon />}
        sx={{
          borderColor: colors.bluePrimary,
          color: colors.bluePrimary,
          '& .MuiChip-label': {
            pl: 1,
          },
        }}
        label={
          <Typography variant="button">
            <T _str="Refine with AI" />
          </Typography>
        }
      />
      {hasRefined && (
        <Button
          onClick={async () => await deleteRefinementMessage()}
          aria-label={t('Undo refine')}
          color="primary"
          id={'btnUndoRefine'}
          sx={{
            width: 40,
            height: 40,
          }}>
          <UndoIcon />
        </Button>
      )}
    </Stack>
  )
}

export default RefineMessageButton
